import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiPhone, HiEnvelope, HiXMark } from 'react-icons/hi2';
import { FaWhatsapp } from 'react-icons/fa';

const EmergencyPanel = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleCall = () => {
    window.location.href = 'tel:+213560667120';
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/213560667120?text=' + encodeURIComponent(t('emergency.description')), '_blank');
  };

  const handleEmail = () => {
    const subject = encodeURIComponent(t('emergency.title'));
    const body = encodeURIComponent(`${t('emergency.description')}\n\n---\n`);
    window.location.href = `mailto:fpra2024@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 z-50"
        onClick={onClose}
      />
      
      {/* Panel */}
      <div className="fixed inset-x-0 bottom-0 md:bottom-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:max-w-md z-50 bg-white dark:bg-gray-900 rounded-t-3xl md:rounded-2xl shadow-2xl p-6 animate-modal">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 end-4 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300"
          aria-label={t('emergency.close')}
        >
          <HiXMark className="h-6 w-6" />
        </button>

        {/* Header */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 dark:bg-orange-900/30 rounded-full mb-3">
            <HiPhone className="h-8 w-8 text-orange dark:text-orange-400" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white dark:text-white mb-2">
            {t('emergency.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            {t('emergency.description')}
          </p>
        </div>

        {/* Action buttons */}
        <div className="space-y-3">
          {/* Call button */}
          <button
            onClick={handleCall}
            className="w-full flex items-center justify-center gap-3 bg-orange hover:bg-orange-600 text-white py-4 px-6 rounded-xl font-semibold transition-colors"
          >
            <HiPhone className="h-6 w-6" />
            <span>{t('emergency.call')}</span>
          </button>

          {/* WhatsApp button */}
          <button
            onClick={handleWhatsApp}
            className="w-full flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white py-4 px-6 rounded-xl font-semibold transition-colors"
          >
            <FaWhatsapp className="h-6 w-6" />
            <span>{t('emergency.whatsapp')}</span>
          </button>

          {/* Email button */}
          <button
            onClick={handleEmail}
            className="w-full flex items-center justify-center gap-3 bg-teal hover:bg-teal-600 text-white py-4 px-6 rounded-xl font-semibold transition-colors"
          >
            <HiEnvelope className="h-6 w-6" />
            <span>{t('emergency.email')}</span>
          </button>
        </div>

        {/* Contact info */}
        <div className="mt-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">FPRA</p>
          <p className="text-sm font-semibold text-gray-900 dark:text-white">+213 560 667 120</p>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">fpra2024@gmail.com</p>
        </div>
      </div>
    </>
  );
};

export default EmergencyPanel;
